import { render, staticRenderFns } from "./ModalRevisedEvidence.vue?vue&type=template&id=a536b974&scoped=true&"
import script from "./ModalRevisedEvidence.vue?vue&type=script&lang=js&"
export * from "./ModalRevisedEvidence.vue?vue&type=script&lang=js&"
import style0 from "./ModalRevisedEvidence.vue?vue&type=style&index=0&id=a536b974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a536b974",
  null
  
)

export default component.exports